import React, { useState } from "react";
import Button from "@streeteasy/design-system/deprecated/Button";
import { bool, func, string } from "prop-types";

import * as S from "./styled";

const ClaimDealModal = props => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <S.UIModal
      isOpen={props.isOpen}
      onRequestClose={() => props.onRequestClose(false)}
      rootElementId={props.rootElementId}
    >
      <S.Container>
        <S.StyledXButton onClick={props.onRequestClose} />
        <S.Body>
          <S.Title>Claim {props.titleAddress}</S.Title>
          <S.CheckboxView
            isChecked={isChecked}
            label="I certify that I was the buyer's agent"
            onChange={() => setIsChecked(!isChecked)}
            theme="primary"
          />
        </S.Body>
        <S.ActionBox>
          <Button
            disabled={!isChecked}
            onClick={() => {
              props.onClickClaim();
            }}
          >
            Claim
          </Button>
        </S.ActionBox>
      </S.Container>
    </S.UIModal>
  );
};

ClaimDealModal.propTypes = {
  isOpen: bool.isRequired,
  onClickClaim: func.isRequired,
  onRequestClose: func.isRequired,
  rootElementId: string.isRequired,
  titleAddress: string.isRequired
};

export default ClaimDealModal;
